module.exports = __webpack_public_path__ + "img/collins-logo.2b2fecc2.jpg";